var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-invoice"},[_c('div',{ref:"imgRef",staticClass:"img-wrapper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }